import React from 'react'
import { KidDashboardDesktop } from '@/components/KidDashboardDesktop'
import { KidsDashboard } from '@/components/KidsDashboard'
import { useMediaQuery } from '@/hooks/useMediaQuery'

/**
 * Kid home page - Shows tile dashboard on desktop, mobile dashboard on mobile
 * Route: /dashboard/home (for kids)
 */
export const KidHomePage: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)')

  if (isDesktop) {
    return <KidDashboardDesktop />
  }

  return <KidsDashboard />
}
